module.exports = __webpack_public_path__ + "static/media/checkbox-pen-outline.182b9479.svg";